import { selectAllStrings, selectCurrentLanguage } from '../language/languageSlice';
import '../../stylesheets/PoiDetailsPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { selectPoiDetails, fetchPoi, fetchFavorites, markFavorite } from './poisSlice';
import { selectPoiImageIds, fetchGallery, selectPoiImageById } from '../gallery/gallerySlice';
import { selectUserPosition, setUserPosition } from '../map/mapSlice';
import { PoiRating } from './PoiList';
import { selectPoiReviewIds, fetchPoiReviews, selectPoiReviewById } from '../reviews/reviewsSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import GalleryImage from '../gallery/GalleryImage';
import { parsePoiAddress } from './parser';
import Review from '../reviews/Review';
import { Loader } from "@googlemaps/js-api-loader";
import constants from '../../constants';
import { useHistory } from 'react-router-dom';
import { getPosition, getCardStatus } from '../../api/mobile';
import ReviewList from '../reviews/ReviewList';
import { fetchUserData } from '../user/userSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import ErrorMessage from '../../app/ErrorMessage';
import AddReviewModal from '../reviews/ReviewModal';
import AddPhotoModal from '../gallery/AddPhotoModal';
import ShareDialog from '../../app/ShareDialog';
import { logEvent, EVENTS } from '../../lib/event-helper';


const PoiDetailsPage = ({ match }) => {
    const {poiId} = match.params;

    const [error, setError] = useState('');

    const [inited, setInited] = useState(false);

    const strings = useSelector(selectAllStrings);

    const poi = useSelector(selectPoiDetails);
    const poiStatus = useSelector(state => state.pois.poiDetails.status);
    const poiError = useSelector(state => state.pois.poiDetails.error);

    const imageIds = useSelector(selectPoiImageIds);
    const galleryStatus = useSelector(state => state.gallery.byPoi.status);
    const galleryError = useSelector(state => state.gallery.byPoi.error);
    const galleryRef = useRef(null);
    const shareDialogRef = useRef(null);

    const reviewIds = useSelector(selectPoiReviewIds);
    const reviewsStatus = useSelector(state => state.reviews.byPoi.status);
    const reviewsError = useSelector(state => state.reviews.byPoi.error);
    const [reviewsLimit, setReviewsLimit] = useState(3);

    const favorites = useSelector(state => state.pois.favorite.poiIds);
    const favoritesStatus = useSelector(state => state.pois.favorite.status);
    const cardData = useSelector(state => state.user.cardData);

    const [liked, setLiked] = useState(null);

    const dispatch = useDispatch();
    const userPosition = useSelector(selectUserPosition);
    const [showGallery, setShowGallery] = useState(false);
    let slideIndex = 1;
    const mapRef = useRef(null);
    const history = useHistory();
    const [showAddReview, setShowAddReview] = useState(false);
    const [showAddPhoto, setShowAddPhoto] = useState(false);
    const currentLanguage = useSelector(selectCurrentLanguage);
    const [position, setPosition] = useState(null);


    const additionalOptions = {
        libraries: ["places"]
    };
    
    const loader = new Loader({
        apiKey: constants.maps_api_key,
        version: "weekly",
        ...additionalOptions,
    });
    const defaultZoom = 16;

    const [mapLink, setMapLink] = useState(null);



    const initMap = () => {
        const position = {
            lat: parseFloat(poi.lat_poi.replace(',', '.')),
            lng: parseFloat(poi.lon_poi.replace(',', '.'))
        };
        setPosition(position);
        let link;
        let address = encodeURIComponent(parsePoiAddress(poi));
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getData) {
            link = `http://maps.apple.com/?daddr=${address}`;
        } else {
            link = `https://www.google.com/maps/dir/?api=1&destination=${address}`;
        }
        setMapLink(link);

        const iconsUrl = constants.frontend_url + '/images/';
        loader.load().then(() => {
            window.Google = google;
            window.map = new google.maps.Map(mapRef.current, {
                center: position,
                zoom: defaultZoom,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: false,
                fullscreenControl: false,
                styles: [
                    {
                        "featureType": "poi",
                        "stylers": [
                            {"visibility": "off"}

                        ]
                    }]
            });
            const markerIcon = 'round_marker.png';
            const marker = new window.Google.maps.Marker({
                position: position,
                icon: iconsUrl + markerIcon,
                map: window.map
            });

        });
        setInited(true);

    };
    useEffect(() => {
        if (poiStatus === 'idle' || (poiStatus === 'succeeded' && poi.id_poi != poiId)) {
            setShowGallery(false);
            setInited(false);
            dispatch(fetchPoi(poiId));
        }
    }, [poiStatus, dispatch, poi, poiId]);

    useEffect(() => {
        if (galleryStatus === 'idle' || (poiStatus === 'succeeded' && poi.id_poi != poiId)) {
            dispatch(fetchGallery(poiId));
        }
    }, [dispatch, galleryStatus, poi, poiId]);

    useEffect(() => {
        if (reviewsStatus === 'idle' || (poiStatus === 'succeeded' && poi.id_poi != poiId)) {
            dispatch(fetchPoiReviews(poiId));

        }
    }, [dispatch, reviewsStatus, poi, poiId]);

    useEffect(async () => {
        if (userPosition === null) {
            let newPosition = await getPosition();
            dispatch(setUserPosition(newPosition));
        }
    }, [dispatch, userPosition]);

    useEffect(() => {
        if (!inited && mapRef.current !== null && poi.id_poi == poiId) {
            initMap();
        }
    }, [inited, mapRef.current, poi, poiId]);


    useEffect(async () => {
        if (favoritesStatus === 'idle') {
            if (cardData.profile_id) {
                dispatch(fetchFavorites(cardData.profile_id));
            }
        }
        if (favoritesStatus === 'succeeded' && favorites.indexOf(poiId) !== -1) {
            setLiked(true);
        }

    }, [dispatch, favoritesStatus]);
    
    const [eventLogged, setEventLogged] = useState(false);
    
    useEffect(() => {
        if(poiId && !eventLogged) {
            logEvent(EVENTS.OPEN_POI, cardData.profile_id || cardData.email, poiId);
            setEventLogged(true);
        }
    }, [poiId])


// Next/previous controls
    function plusSlides(n) {
        showSlides(slideIndex += n);
    }


    function showSlides(n, fade = true) {
        var i;
        var slides = document.getElementsByClassName("mySlides");

        if (n > slides.length) {
            slideIndex = 1;
        }
        if (n < 1) {
            slideIndex = slides.length;
        }
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
            //slides[i].classList.remove('fade');
        }
        if (typeof slides[slideIndex - 1] !== 'undefined') {
            slides[slideIndex - 1].style.display = "block";
            if (fade) {
                slides[slideIndex - 1].classList.add('fade');
            }
    }
    }
    ;

    const [showShare, setShowShare] = useState(false);
    let shareLink;
    if (window.webkit && window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getData) {
        shareLink = 'https://www.pleinairclub.it/app';
    } else {
        shareLink = 'share';
    }
    const openShareDialog = (event) => {
        if (navigator.share) {
            event.preventDefault();
            navigator.share({
                text: strings.it_very_usefull,
                url: shareLink
            }).then(() => {
                console.log('Thanks for sharing!');
            })
                    .catch(console.error);
        }
    };
    const closeShareDialog = (event = null) => {
        if (event !== null) {
            event.preventDefault();
        }
        setShowShare(false);
    };

    const seeMoreReviews = (event) => {
        event.preventDefault();
        setReviewsLimit(reviewsLimit + 3);
    };

    const likeClicked = async (event, isLiked) => {
        event.preventDefault();
        if (cardData.profile_id) {
            setLiked(isLiked);
            dispatch(markFavorite({userId: cardData.profile_id, poiId: poiId, add: isLiked}));
        } else {
            setError(strings.trial_not_allowed);
        }
    };
    const onAddReviewClicked = () => {
        if (cardData.profile_id) {
            setShowAddReview(true);
        } else {
            setError(strings.trial_not_allowed);
        }
    };
    const onAddPhotoClicked = () => {
        if (cardData.profile_id) {
            setShowAddPhoto(true);
        } else {
            setError(strings.trial_not_allowed);
        }
    };
    let categoryImage = null;
    if (poi.cat_camping == 1) {
        categoryImage = constants.backend_url + '/images/campeggi.png';
    } else if (poi.cat_areeservizio == 1) {
        categoryImage = constants.backend_url + '/images/servizi.png';
    } else if (poi.cat_convenzioni == 1) {
        categoryImage = constants.backend_url + '/images/vantaggi.png';
    } else if (poi.cat_areesosta == 1) {
        categoryImage = constants.backend_url + '/images/sosta.png';
    }

    const mapLinkRef = useRef(null);

 

    return <section>
        {poiStatus === 'loading' ? <div className="loader"></div> : poiStatus === 'succeeded' ?
                    <article className="poi-details-page">
                        <div className="header">
                            <a className="go-back" onClick={history.goBack}></a>
                            <div className="gallery">
                
                                {galleryStatus === 'loading' ? <div className="loader"></div> : galleryStatus === 'succeeded' ?
                                        <div className="slideshow-container" ref={galleryRef}>
                                            {imageIds.length > 0 ? imageIds.map((imageId, index) => <GalleryImage key={imageId} imageId={imageId} index={index} gallerySize={imageIds.length} selector={selectPoiImageById}/>) : <div className="mySlides">
                                                <div className="numbertext">1/1</div>
                                                <img src={categoryImage} />
                                            </div>}
                                        </div>
                                                : <div>{galleryError}</div>}
                
                                                {imageIds.length > 1 ? <a className="prev" href="#" onClick={event => { event.preventDefault(); plusSlides(-1) }}></a> : null}
                                {imageIds.length > 1 ? <a className="next" href="#" onClick={event => { event.preventDefault(); plusSlides(1)}}></a> : null}
                            </div>
                        </div>
                        <div className="content">
                            <button id="like_button" className={liked ? 'liked' : ''} onClick={(event) => likeClicked(event, !liked)}>
                                <FontAwesomeIcon icon={faHeart}/>
                            </button>
                            <h1>{poi.nome_poi}</h1>
                            <div className="full-address">{parsePoiAddress(poi)}</div>
                            <div className="distance">{poi.distance + ' ' + strings.km}</div>
                
                            <PoiRating rating={poi.average}/>
                            <div className="button-list">
                                <button id="add_review" onClick={onAddReviewClicked}><span>{strings.add_review}</span></button>
                                <button id="add_photo" onClick={onAddPhotoClicked}><span>{strings.add_photo}</span></button>
                                <a id="share" onClick={openShareDialog} href={shareLink} target="_blank"><span>{strings.share}</span></a>
                            </div>
                            {(currentLanguage === 'it' && poi.sconto_poi) || 
                                    (currentLanguage === 'en' && 
                                    poi.sconto_poi_en) ?
                                        <div className="discount">
                                            <h2>{strings.discount}</h2>
                                            <div dangerouslySetInnerHTML={{__html: currentLanguage === 'en' ? poi.sconto_poi_en : poi.sconto_poi}}></div>
                                        </div> : null}
                            <h2>{strings.description}</h2>
                            <div className="description">
                                {currentLanguage === 'en' ? poi.app_desc_en : poi.app_desc}
                            </div>
                            <h2>{strings.open}</h2>
                            <div className="open-from">{poi.apertodal_poi}-{poi.apertoal_poi}</div>
                            <h2>{strings.services}</h2>
                            <div className="services">{poi.servizi}</div>
                            <div id="map_wrapper">
                                <div id="map" ref={mapRef}></div>
                                <a href={mapLink} target="_blank" ref={mapLinkRef} onClick={() => logEvent(EVENTS.SET_NAVIGATION_TO_POI, cardData.profile_id || cardData.email, poiId)} className="map-overlappi"></a>
                            </div>
                
                            <div className="label">{strings.address}</div>
                            <div className="address">{poi.indirizzo_poi}</div>
                            <div className="label">{strings.phone}</div>
                            <div className="phone"><a className="active-link" href={'tel:'+poi.telefono_poi} target="_blank" onClick={() => logEvent(EVENTS.PHONE_CALL, cardData.profile_id, poiId)}>{poi.telefono_poi}</a></div>
                            <div className="label">{strings.email}</div>
                            <div className="email"><a href={'mailto:' + poi.email_poi} className="active-link" target="_blank">{poi.email_poi}</a></div>
                            <div className="label">{strings.website}</div>
                            <div className="website">{poi.sitoweb_poi ? <a href={'//' + (poi.sitoweb_poi.replace('https://', '').replace('http://', ''))} className="active-link" target="_blank">{poi.sitoweb_poi}</a> : null}</div>
                            <div className="reviews"> 
                                <h2>{strings.latest_reviews}</h2>
                                <ReviewList reviewIds={reviewIds} reviewsStatus={reviewsStatus} reviewsLimit={reviewsLimit} reviewsError={reviewsError} selectById={selectPoiReviewById}/>
                
                                {reviewIds.length > reviewsLimit ? <button className="btn" id="show_more_reviews" onClick={seeMoreReviews}>{strings.see_more_reviews}</button> : null}
                            </div>
                        </div>
                    </article>
                        : <div>{poiError}</div>  }
        {showShare ? <ShareDialog link={shareLink} onClose={closeShareDialog}/> : null}
    
        {error ? <ErrorMessage message={error} onGoBack={() => setError('')}/> : null}
        {showAddReview ? <AddReviewModal onGoBack={() => setShowAddReview(false)} poiId={poiId}/> : null}
        {showAddPhoto ? <AddPhotoModal onGoBack={() => setShowAddPhoto(false)} poiId={poiId}/> : null}
    
    </section>

};

export default PoiDetailsPage;